module.exports = __webpack_public_path__ + "static/posting_4.ed2a1197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/checkout/assets/2x/posting_4.jpg
// module id = 326
// module chunks = 48050446922739